import { ClassEditor } from "@/features/class/pages/ClassListPage/ClassEditor";

import type { Control } from "react-hook-form";
import type { ClassEditorState } from "@/features/class/pages/ClassListPage/ClassEditor";
import { FormConfirmDialog } from "@/components/FormConfirmDialog";

export function ClassEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<ClassEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <ClassEditor control={control} />
    </FormConfirmDialog>
  );
}
